var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosMicrosoftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_8462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60413 7.60413H0V0H7.60413V7.60413Z",
    fill: "#F1511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 7.60413H8.39551V0H15.9996V7.60413Z",
    fill: "#80CC28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60394 16.0001H0V8.396H7.60394V16.0001Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 16.0001H8.39551V8.396H15.9996V16.0001Z",
    fill: "#FBBC09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_8462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosMicrosoftIcon);
export default __webpack_public_path__ + "static/media/logos_microsoft-icon.eb4ed444c3cd186b90ebb2197d12fadf.svg";
export { ForwardRef as ReactComponent };